import variables from '../../variables';

const reused = {
  articleCarousel: {
	  target: '.js-article-carousel',
	  apiOptions: {
		  spaceBetween: 15,
		  slidesPerView: 1,
		  allowTouchMove: true,
		  speed: variables.carouselDefaultDuration
	  },
	  customOptions: {
		  navHolder: '.js-article-carousel-controls'
	  }
  }
};

export default reused;
